import React from "react";
import INRTransactionsPage from "../INRTransactionsPage";

const INRDeposit = () => <INRTransactionsPage type="DEPOSIT" />;

export default INRDeposit;
